import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  setUnreadOngoingMessage,
  setUnreadPendingMessage,
} from "redux/chats/chats.actions";
import useTranslation from "hooks/useTranslation";
import styles from "./styles.module.scss";
import { CloseOutlineIconComponent } from "assets/icons";
import ConvSelectHead from "./components/ConvSelectHead";
import DepartmentSelect from "./components/DepartmentsSelect";
import CloseConvModal from "./components/CloseConvsModal";
import SortConvsMenu from "./components/SortConvsMenu";

const getAgent = ({ userData }) => userData.agent.data;
const getOngoingConversations = ({ chatsData }) => chatsData.ongoing.data;
const getPendingConversations = ({ chatsData }) => chatsData.pending.data;
const getAllTeams = ({ chatsData }) => chatsData.teams.memberofTeams;

const UserListFilter = ({
  selectedDepartmentFilter,
  setSelectedDepartmentFilter,
  selectedConversations,
  setSelectedConvType,
  unreadOngoingMessage,
  unreadPendingMessage,
  sortOrder,
  setSortOrder,
}) => {
  const agent = useSelector(getAgent);
  const ongoingConversations = useSelector(getOngoingConversations);
  const pendingConversations = useSelector(getPendingConversations);
  const allTeams = useSelector(getAllTeams);

  const dispatch = useDispatch();
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();
  const [isCloseBtnHovered, setIsClosedBtnHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [removeIncomingConvs, setRemoveIncomingConvs] = useState(false);

  const conversationsOnType = {
    ongoing: ongoingConversations,
    pending: pendingConversations,
  };

  const showCloseAllBtn =
    ["pending", "ongoing"].includes(selectedConversations) &&
    !!conversationsOnType[selectedConversations].length;

  const handleSelectFilter = (filter) => {
    setSelectedConvType(filter);

    switch (filter) {
      case "pending":
        dispatch(setUnreadPendingMessage(false));
        break;
      case "ongoing":
        dispatch(setUnreadOngoingMessage(false));
        break;
      default:
        break;
    }
  };

  const handleCloseAllConversations = (event) => {
    event.stopPropagation();

    setShowModal(true);

    if (selectedConversations === "pending") {
      setRemoveIncomingConvs(true);
    }
  };

  const handleSelectConvType = (type) => {
    handleSelectFilter(type);
  };

  const renderCloseConvsBtn = (
    <div
      onMouseEnter={() => setIsClosedBtnHovered(true)}
      onMouseLeave={() => setIsClosedBtnHovered(false)}
      className={styles.close_all_convs}
      onClick={handleCloseAllConversations}
    >
      <span> {t("CLOSE_ALL")} </span>
      <CloseOutlineIconComponent />
    </div>
  );

  const renderConvsTypesSelectors = ["ongoing", "pending", "otherConvs"].map(
    (type) => (
      <ConvSelectHead
        key={type}
        type={type}
        selectedType={selectedConversations}
        onSelectConvType={handleSelectConvType}
      />
    )
  );

  useEffect(() => {
    switch (selectedConversations) {
      case "pending":
        if (unreadPendingMessage) {
          dispatch(setUnreadPendingMessage(false));
        }
        break;
      case "ongoing":
        if (unreadOngoingMessage) {
          dispatch(setUnreadOngoingMessage(false));
        }
        break;

      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreadOngoingMessage, unreadPendingMessage]);

  return (
    <>
      <CloseConvModal
        showModal={showModal}
        setShowModal={setShowModal}
        agentId={agent.id}
        removeIncomingConvs={removeIncomingConvs}
        setRemoveIncomingConvs={setRemoveIncomingConvs}
        selectedConversations={selectedConversations}
      />

      <div className={styles.filter_container}>
        <div className={styles.conv_type_select}>
          {renderConvsTypesSelectors}
        </div>
        <div className={styles.tools}>
          <SortConvsMenu sortOrder={sortOrder} setSortOrder={setSortOrder} />

          {!isCloseBtnHovered && (
            <DepartmentSelect
              selected={selectedDepartmentFilter}
              setSelected={setSelectedDepartmentFilter}
              teams={allTeams}
            />
          )}

          <div className={styles.close_all_wrapper}>
            {showCloseAllBtn && renderCloseConvsBtn}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserListFilter;
